import { Component, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'pcs-select-item',
  template: '<ng-content></ng-content>',
  styleUrls: ['./select-item.component.scss']
})
export class SelectItemComponent {
  @Input() option;
  @Input() active = false;
  @Input() selected = false;
  @HostBinding('class.disabled')
  @Input() disabled = false;

  @HostBinding('class.active')
  get selectedOrActive() {
    return this.selected || this.active;
  }

  @Output() selectItemClick = new EventEmitter<any>();

  @HostListener('click')
  onClick() {
    if (!this.disabled) {
      this.selectItemClick.next(this.option);
    }
  }

}
